import { useAuth } from 'hooks/useAuth'
import { Relations } from 'components/relations/relations'

export function MyRelations() {
  const { user } = useAuth()
  return <Relations exhibitorId={user?.exhibitorId} tradeshowId={user?.tradeShowId} />
}
